import React, { useLayoutEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { PublicFooter, PublicHeader, useIsUserAuth } from 'components';

import ConfirmOrder from 'src/features/orderConfirmations/containers/ConfirmOrder';
import shared from 'src/styles/custom/Shared.module.scss';

import SupplierRegister from '../onboarding/containers/SupplierRegister';

const ConfirmOrderPage = () => {
  const isAuth = useIsUserAuth();
  const history = useHistory();
  const params = useParams();

  useLayoutEffect(() => {
    if (isAuth) {
      history.push(`/supplier/orders/${params?.uid}`);
    }
  }, [isAuth]);

  return (
    <>
      <PublicHeader supplierForm />
      <div className={shared.publicContainer}>
        <SupplierRegister />
        <ConfirmOrder />
      </div>
      <PublicFooter />
    </>
  );
};

export default ConfirmOrderPage;
